const LAYERS_NUM = 10;
export type LayerIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

function fibonacci(n: number): number {
  return n < 1 ? 0 : n <= 2 ? 1 : fibonacci(n - 1) + fibonacci(n - 2);
}

function generate(num = LAYERS_NUM, offset = 0) {
  return [offset].concat(
    Array(num - 1)
      .fill(0)
      .map((_, i) => fibonacci(i + 2) + offset),
  );
}

export type Levels = 'UNDERLAY' | 'MIDDLE' | 'OVERLAY' | 'MODAL';

/*
 * Z-INDEX:
 * --------------------------------------------------------------------------------
 * index:     0      1      2      3      4      5      6      7      8      9
 * --------------------------------------------------------------------------------
 * UNDERLAY: [0,     1,     2,     3,     5,     8,     13,    21,    34,    55],
 * MIDDLE:   [100,   101,   102,   103,   105,   108,   113,   121,   134,   155],
 * OVERLAY:  [1000,  1001,  1002,  1003,  1005,  1008,  1013,  1021,  1034,  1055],
 * MODAL:    [10000, 10001, 10002, 10003, 10005, 10008, 10013, 10021, 10034, 10055],
 *
 */

export const zIndex: { [key in Levels]: number[] } = {
  UNDERLAY: generate(LAYERS_NUM, 0),
  MIDDLE: generate(LAYERS_NUM, 100),
  OVERLAY: generate(LAYERS_NUM, 1000),
  MODAL: generate(LAYERS_NUM, 10000),
};
